// removed by extract-text-webpack-plugin
module.exports = {"triangle":"index__triangle___2H9DB","left":"index__left___2VmW1","right":"index__right___MB6fz","up":"index__up___1aUAQ","down":"index__down___1hPc4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Triangle/index.css
// module id = 730
// module chunks = 12